export const iconFontAwesomeHalloweenSkull = (
	<i className="fa-solid fa-skull"></i>
);
